import styled from "styled-components";
import { default as BaseSelect } from "../../select/Select";
import { Input, Selected, SelectedItemInput } from "../../select/styled/select";

export const Container = styled.form`
  display: flex;
  align-items: center;
  width: 100%;

  svg {
    margin-left: 1rem;
    fill: ${({ theme }) => theme.prevColors.streamsBlue};
  }
`;

export const Select = styled(BaseSelect)`
  border: 0;
  background-color: transparent;

  ${Selected} {
    padding: 0;
  }

  ${SelectedItemInput} {
    margin: 0;
  }

  ${Input} {
    ${({ theme }) => theme.text.h2};
    width: 24.5rem;
    line-height: normal;
    padding: 0;
    color: ${({ theme }) => theme.prevColors.greyDark};
    border: 0;
    border-bottom: 0.2rem dashed
      ${({ theme, hasName }) =>
        hasName ? "transparent" : theme.prevColors.greyLight};
    border-radius: 0;
    background-color: transparent;

    @media (max-width: ${({ theme }) => theme.breakpoints.page.twoColumn}px) {
      width: 100%;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.page.oneColumn}px) {
      text-align: center;
    }

    &::placeholder {
      color: ${({ theme }) => theme.prevColors.blackLight};
    }

    &:hover {
      color: ${({ theme, hasName }) =>
        hasName ? theme.prevColors.grey : theme.prevColors.greyDark};
    }

    &:hover:focus {
      color: ${({ theme }) => theme.prevColors.greyDark};
    }

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.prevColors.streamsBlue};

      &::placeholder {
        color: ${({ theme }) => theme.prevColors.blackLight};
      }
    }
  }
`;
